import {
    showWarnMessage,
    showTitleConfirm,
    showOnDeleteRecord,
    showInfoMessage
} from '../../../../_shared/Messages/actions/MessageActions';
import * as screenActions from '../../Common/actions/Screen';
import * as fieldActions from '../../Common/actions/Field';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {messagesIds} from '../../../../_shared/Messages/consts';
import {showSuccessToast} from '../../../../components/Toast/actions/ToastActions';
import templateTexts from '../texts';
import {TemplateField} from '../stores/TemplateField';
import {getLang} from '../../../../Localization';

let updateTemplateReadonlyServer;
let deleteTemplateServer;
let editTemplateServer;
let uploadTemplateFileServer;
let changeTemplateNameServer;
let cloneTemplateServer;

export function initFunctions(funcs) {
    updateTemplateReadonlyServer = funcs.updateTemplateReadonly;
    deleteTemplateServer = funcs.deleteTemplate;
    editTemplateServer = funcs.editTemplate;
    uploadTemplateFileServer = funcs.uploadTemplateFile;
    changeTemplateNameServer = funcs.changeTemplateName;
    cloneTemplateServer = funcs.cloneTemplate;
}

export function changeTitle(field: TemplateField, newTitle, cancelCallback) {
    const errMsg = getLocalizedText(texts.doubleTab);
    const {screen} = field;
    const title = newTitle.trim();
    const double = field.doesTitleNeedChecks && field.isNewNameDouble(newTitle);
    if (double) {
        if (!field.isDoubleTitleAllowed) {
            showWarnMessage({
                id: messagesIds.screens.changeFieldTitleWarn,
                title: errMsg,
                onClose: cancelCallback
            });
        } else {
            showTitleConfirm(
                messagesIds.screens.changeTemplateTitleConfirm,
                screen.entityName,
                () => fieldActions.setNewTitle(field, title),
                cancelCallback
            );
        }
    } else if (title.length > 0) {
        setNewTitleSrv && setNewTitleSrv(field, field.title, newTitle, cancelCallback);
        field.setTitle(title);
        field.setChanging(false);
    } else {
        field.cancelTitleChange();
    }
}

function setNewTitleSrv(field: TemplateField, newTitle, title, cancelCallback) {
    if (!field.isNewTemplate && field.title !== title) {
        changeTemplateNameServer &&
            changeTemplateNameServer(field.template, newTitle, title, cancelCallback);
    }
}

export function updateTemplateReadonly(field: TemplateField) {
    updateTemplateReadonlyServer(field.template, !field.readOnly);
    field.setReadOnly(!field.readOnly);
}

export function deleteTemplate(field: TemplateField) {
    const {screen} = field;
    if (field.isNewTemplate || field.isDefaultTemplate) {
        return;
    }

    showOnDeleteRecord(() => {
        deleteTemplateServer(field.template);
        screen.collection.deleteField(field);
    });
}

export function editTemplate(field: TemplateField) {
    if (field.isOld || field.isNewTemplate) {
        return;
    }
    !field.isDefaultTemplate && field.setActive(true);
    editTemplateServer(field.template, field.lang || getLang());
    const messageContent = field.isDefaultTemplate
        ? templateTexts.defaultTemplateDownload
        : `${templateTexts.editMessagesContet} "${field.title}"`;
    showInfoMessage({title: templateTexts.newTemplateMessageTitle, content: messageContent});
}

export function uploadTemplateFile(field: TemplateField) {
    const {screen} = field;
    // disable uploading file to a default template or an old template
    if (field.isDefaultTemplate || field.isOld) {
        return;
    }
    uploadTemplateFileServer(
        field.template,
        field.title,
        field.lang,
        () => {
            screen.setLoading(true);
        },
        fileName => {
            screenActions.getData(screen);
            field.setActive(false);
            showSuccessToast(`${templateTexts.theFile} "${fileName}" ${templateTexts.uploaded}`);
        }
    );
}

export function cloneTemplate(field: TemplateField) {
    const {screen} = field;
    cloneTemplateServer(
        field.template,
        getLocalizedText(texts.copyOfLabel) + ' ' + field.title,
        () => {
            screen.setLoading(true);
        },
        () => {
            screenActions.getData(screen);
        }
    );
}
